module.exports = __webpack_public_path__ + "posture/static/img/pelvis_lean_normal.075c49e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/posture/normal/pelvis_lean_normal.png
// module id = 3I8+
// module chunks = 1